/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventFloorDay,
    JsonEventFloorDayFromJSON,
    JsonEventFloorDayFromJSONTyped,
    JsonEventFloorDayToJSON,
} from './JsonEventFloorDay';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventFloorDay
 */
export interface ApiResultOfJsonEventFloorDay {
    /**
     * 
     * @type {JsonEventFloorDay}
     * @memberof ApiResultOfJsonEventFloorDay
     */
    data?: JsonEventFloorDay;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventFloorDay
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventFloorDay
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventFloorDay
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventFloorDay
     */
    result?: ApiResultOfJsonEventFloorDayResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventFloorDayResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventFloorDayFromJSON(json: any): ApiResultOfJsonEventFloorDay {
    return ApiResultOfJsonEventFloorDayFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventFloorDayFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventFloorDay {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventFloorDayFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventFloorDayToJSON(value?: ApiResultOfJsonEventFloorDay | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventFloorDayToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

